import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthCon from "./useAthCon";
import useAuth from "./useAuth";
import LoadingSpinner from "../composant_reutilisable/loading";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Modal, Button, Form } from 'react-bootstrap';
import { getAuthToken } from "./authToken";

const Connexion = (show, onHide, onSend) => {
    useAuthCon();
    const navigate = useNavigate();
    const { login } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({ email: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [alert, setAlert] = useState({ message: "", type: "" });

    // Gérer la saisie des champs
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Affichage des alertes
    const showAlert = (message, type = "danger") => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: "", type: "" });
        }, 5000);
    };

    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setAlert({ message: '', type: '' });
    };


    // Gérer l'envoi du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/connexion/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            // console.log("Réponse du backend :", data); // Debug

            // setIsLoading(false);

            if (response.ok) {
                login(data.utilisateur);
                const tokenCle = await getAuthToken();
                localStorage.setItem('access_token', tokenCle);
                localStorage.setItem("userId", data.utilisateur.id);
                localStorage.setItem("groupe_id", data.utilisateur.groupe_id);
                localStorage.setItem("code_expires_at", data.utilisateur.code_expires_at);
                // console.log(data.utilisateur.groupe_id)
                // showAlert("Connexion réussie !", "success");
                navigate("/Calendrier");
                // navigate("/verification", { state: { email: formData.email, code_expires_at: data.utilisateur.code_expires_at } });

            } else {
                showAlert(data.message || "Erreur d'authentification.", "danger");
            }
        } catch (error) {
            setIsLoading(false);
            showAlert("Erreur de connexion au serveur.", "danger");
        } finally {
            setIsLoading(false);
        }
    };

    const handleInscription = () => {
        navigate("/Inscription");
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();

        const response = await fetch(`${process.env.REACT_APP_HOTE}/mot-de-passe-oublie/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email }),
        });

        const data = await response.json();
        if (response.ok) {
            setShowModal(false);
            showAlert("Un lien a été envoyer sur votre adresse email pour reinitialiser votre compte.", 'success');

        } else {
            setShowModal(false);
            showAlert(data.message || "Une erreur est survenue.");

        }
    };



    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <div
                    className="loginColumns animated fadeInDown"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                    }}
                >
                    <div className="ibox" style={{ width: "100%", maxWidth: "400px" }}>
                        <div className="ibox-content">
                            <h3 className="text-center">
                                <strong>O'MEL Services</strong>
                            </h3>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                            )}

                            <form role="form" className="p-2" onSubmit={handleSubmit}>
                                <div className="form-group mb-0">
                                    <label className="col-form-label">Email</label>
                                    <div className="">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Entrez votre email"
                                            className="form-control pe-5"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group mt-2">
                                    <label className=" col-form-label">Mot de passe</label>
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder="Entrez votre mot de passe"
                                            className="form-control"
                                            value={formData.password}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "15px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                color: "#666",
                                            }}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>

                                </div>
                                <div className="mt-4">
                                    <button
                                        className="btn btn-sm btn-success col-md-12 mb-2"
                                        type="submit"
                                    >
                                        <strong>Connexion</strong>
                                    </button>

                                    {/* <button
                                        className="btn btn-outline btn-success col-md-12"
                                        type="button"
                                        onClick={handleInscription}
                                    >
                                        <strong>Inscription</strong>
                                    </button> */}
                                </div>


                            </form>
                        </div>
                        {/* <div className="row">
                            <div class="col-md-12 w-100 text-center">
                                <small><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>ADN Services</a> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>INOVACT SARL</a></small>
                            </div>
                        </div> */}

                        <Modal show={showModal} onHide={handleCloseModal} centered>
                            <Modal.Header>
                                <Modal.Title>Réinitialiser le mot de passe</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group controlId="email">
                                        <Form.Label>Votre email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Entrer votre email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                    {message && (
                                        <div className="mt-3">
                                            <small className="text-muted">{message}</small>
                                        </div>
                                    )}
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseModal}>
                                    Fermer
                                </Button>
                                <Button variant="success" onClick={handleResetPassword}>
                                    Reinitialiser
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            )}
        </>
    );
};

export default Connexion;
